module.exports = __webpack_public_path__ + "img/Walker.12ca9aa6.png";